export const DEAL_STAGE_OPTIONS: { label: string; value: string }[] = [
	{ label: 'Appointment No Show', value: 'Appointment No Show' },
	{ label: 'Appointment Rescheduled', value: 'Appointment Rescheduled' },
	{ label: 'Appointment scheduled', value: 'Appointment scheduled' },
	{ label: 'Best Case', value: 'Best Case' },
	{ label: 'Closed lost', value: 'Closed lost' },
	{ label: 'Closed won', value: 'Closed won' },
	{ label: 'Commit', value: 'Commit' },
	{ label: 'Scheduled Pipeline', value: 'Scheduled Pipeline' },
	{ label: 'Unscheduled Pipeline', value: 'Unscheduled Pipeline' },
];
